import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { settingService } from "../../../services/extensions";
import { Dropdown } from "primereact/dropdown";
import { Util } from "../../../services";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import AddProjectsForm from "./projects-form";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { InputText } from "primereact/inputtext";
import { SplitButton } from "primereact/splitbutton";
import ImportPopup from "../importpopup/importPop";

function Projects() {
  const [projects, setProjects] = useState([]);
  const [selectCustomer, setSelectCustomer] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  const [projectDialog, setProjectDialog] = useState(false);
  const [importDialog, setImportDialog] = useState(false);
  const dt = useRef(null);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [selectCode, setSelectCode] = useState([]);
  const [allCodes, setAllCode] = useState([]);

  useEffect(() => {
    getProjects();
    getCustomers();

  }, []);

  const getProjects = () => {
    settingService.getProjects().then((resp) => {
      setProjects(resp.data.data);
      setAllProjects(resp.data.data);

      let proCode = resp.data.data.map((item) => {
        return item.code;
      });
      setAllCode(proCode);
    });
  };

  const getCustomers = () => {
    settingService.getCustomers().then((resp) => {
      setAllCustomers(resp.data.data);
    });
  };

  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
    if (status === 2) return "REJECT";
    if (status === 3) return "UPCOMING";
    if (status === 4) return "ARCHIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
    if (status === 2) return "red";
    if (status === 3) return "#cb7205";
    if (status === 4) return "rgb(222 204 90)";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ color: fetchStatusColor(data.status), borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  };

  const filterCustomer = (data, allProjects) => {
    setSelectCustomer(data);
    let projFilter = allProjects.filter((item) => {
      return item.customerId === data.id;
    });
    setProjects(projFilter);
  };


  const addProject = () => {
    setProjectDialog(true);
  };

  const onHide = () => {
    setProjectDialog(false);
  };

  const closeProjectDialog = () => {
    setProjectDialog(false);
    getProjects();
  };

  const NewProjectDialog = () => {
    return (
      <Dialog
        // style={{ width: "30vw" }}
        className="modal_width"
        header="Add Project"
        visible={projectDialog}
        onHide={() => onHide()}>
        <AddProjectsForm
          onClose={(e) => {
            closeProjectDialog();
          }} />
      </Dialog>
    );
  };

  const exportExcel = () => {
    Util.exportExcel(projects, "Projects");
  };

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const cols = [
    { field: "id", header: "Id" },
    { field: "code", header: "Code" },
    { field: "title", header: "Title" },
    { field: "status", header: "Status" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportPdf = () => {
    Util.exportAsPdf(exportColumns, projects, "Projects");
  };

  const items = [
    {
      label: "CSV",
      icon: "pi pi-file-export",
      command: () => {
        exportCSV();
      },
    },
    {
      label: "EXCEL",
      icon: "pi pi-file-excel",
      command: () => {
        exportExcel();
      },
    },
    {
      label: "PDF",
      icon: "pi pi-file-pdf",
      command: () => {
        exportPdf();
      },
    },
  ];

  const onClickDeallocation = (rowData) => {
    setImportDialog(true);
  }
  const onHideImport = () => {
    setImportDialog(false);
  };

  const OpenimportDialog = () => {
    return (
      <Dialog className="pop-up-dialog" header="Import" footer={<Button label="Submit"></Button>} visible={importDialog} onHide={() => onHideImport()}>
        <ImportPopup
          onClose={(e) => {
            setImportDialog(false);
          }}
          type="project" />
      </Dialog>
    );
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button mr-2"
          onClick={() => addProject()}
        ></Button>
        <Button
          type="button"
          label="Delete"
          icon="pi pi-trash"
          className="p-button-danger"
          disabled={disabled}
          onClick={deleteConfirm}
        ></Button>
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          label="Import"
          icon="pi pi-plus"
          className="mr-2"
          onClick={() => {
            onClickDeallocation(rowData);
          }} />
        <SplitButton
          label="Export"
          icon="pi pi-download"
          className="p-button-info"
          model={items}
          appendTo="self" />
      </React.Fragment>
    );
  };

  const filterCode = (data, allProjects) => {
    setSelectCode(data);
    let projFilter = allProjects.filter((item) => {
      return item.code === data;
    });
    setProjects(projFilter);
  };


  const rightDropdownTemplate = () => {
    return (
      <React.Fragment>
        <div className="mt-3 mr-3">
          <h3>Select Project Code</h3>
        </div>
        <Dropdown
          filter
          style={{ marginRight: "10px" }}
          placeholder="Select Project Code"
          options={allCodes}
          value={selectCode}
          onChange={(e) => filterCode(e.value, allProjects)}
          appendTo="self"
          className="project_code"
        ></Dropdown>
        <div className="mt-3 mr-3">
          <h3>Select Customer</h3>
        </div>
        <Dropdown
          filter
          // style={{ width: "250px" }}
          placeholder="Select customer"
          optionLabel="title"
          options={allCustomers}
          value={selectCustomer}
          onChange={(e) => filterCustomer(e.value, allProjects)}
          appendTo="self"
          className="all_customer"
        ></Dropdown>
      </React.Fragment>
    );
  };

  const editProjectRowComplete = (e) => {
    let _project = [...projects];
    let { newData, index } = e;
    _project[index] = newData;

    let param = {
      id: _project[index].id,
      code: _project[index].code,
      title: _project[index].title,
      status: _project[index].status,
    };

    try {
      settingService.updateProject(param).then(
        (resp) => {
          if (resp) {
            toast.success("Project updated successfully!");
            getProjects();
          }
        },
        (err) => {
          toast.error("Unable to update project");
        }
      );
    } catch (error) {
      toast.error("Unable to update project");
    }
  };

  const codeEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.toUpperCase())}></InputText>
    );
  };

  const titleEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1))}></InputText>
    );
  };

  const statuses = [
    { label: "INACTIVE", value: 0 },
    { label: "ACTIVE", value: 1 },
    { label: "ARCHIVE", value: 4 },
  ];

  const statusEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select a Status"
        itemTemplate={(option) => {
          return (
            <span className={`product-badge status-${option.label.toLowerCase()}`}>{option.label}</span>
          );
        }} />
    );
  };

  const deleteProject = (e, row) => {
    confirmDialog({
      target: e.currentTarget,
      message: "Are you sure you want to delete?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => {
        settingService.deleteProjectById(row.id).then(
          (resp) => {
            toast.success("Project deleted successfully!");
            getProjects();
          },
          (error) => { }
        );
      },
      accept: () => { },
    });
  };

  const deleteProjectByRow = (row) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={(e) => deleteProject(e, row)}
        ></Button>
      </React.Fragment>
    );
  };

  /* FOR CONFIRMATION DIAGOG BOX */
  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);
  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const deleteConfirm = () => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptFunc(),
      reject,
    });
  };

  const acceptFunc = () => {
    var projectIdList = [];
    selectedProjects.map((item, key) => {
      projectIdList[key] = item.id;
    });
    let param = {
      Ids: projectIdList,
    };
    try {
      settingService.deleteAllProject(param).then(
        (resp) => {
          toast.success("Projects deleted");
          setSelectedProjects([]);
          getProjects();
        },
        (err) => {
          toast.error(err.response.data.error);
          setSelectedProjects([]);
        }
      );
    } catch (error) {
      toast.error("Unable to project");
    }
  };

  const onCheckProjects = (e) => {
    setSelectedProjects(e.value);
    if (e.value.length > 0) {
      setDisabled(false);
    }
  };

  return (
    <div>
      <div>
        <Toolbar
          className="mb-2"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>
      </div>
      <div>
        <Toolbar
          className="mb-2"
          left=""
          right={rightDropdownTemplate}
        ></Toolbar>
      </div>
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={projects}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            editMode="row"
            onRowEditComplete={editProjectRowComplete}
            ref={dt}
            selectionMode="checkbox"
            selection={selectedProjects}
            onSelectionChange={(e) => onCheckProjects(e)}>
            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
            <Column field="code" header="Code" headerStyle={{ width: "8rem" }} sortable editor={(options) => codeEditor(options)}></Column>
            <Column
              field="title"
              header="Title"
              headerStyle={{ width: "8rem" }}
              sortable
              editor={(options) => titleEditor(options)}
            ></Column>
            <Column
              field="status"
              header="Status"
              headerStyle={{ width: "8rem" }}
              body={statusBodyTemplate}
              editor={(options) => statusEditor(options)}
              style={{ width: "20%" }}
            ></Column>
            <Column
              rowEditor
              headerStyle={{ width: "10%", minWidth: "8rem" }}
              bodyStyle={{ textAlign: "right" }}
            ></Column>
            <Column
              rowEditor
              style={{ minWidth: "8rem" }}
              exportable={false}
              body={deleteProjectByRow}
              headerStyle={{ width: "10%", minWidth: "8rem" }}
            ></Column>
          </DataTable>
        </div>
        {OpenimportDialog()}
        {NewProjectDialog()}
      </div>
    </div>
  );
}

export default Projects;